// assets
import { LoginOutlined, ProfileOutlined } from '@ant-design/icons';

// icons
const icons = {
  LoginOutlined,
  ProfileOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
  id: 'authentication',
  title: 'Authentication',
  type: 'group',
  children: [
    {
      id: 'logout1',
      title: 'Logout',
      type: 'item',
      url: '/logout',
      icon: icons.LogoutOutlined || icons.LoginOutlined,
      target: false
    }
  ]
};

export default pages;
